import { Component, OnInit, OnDestroy } from '@angular/core';
import { TableHeader, SortInfo, CommonConstants, ColumnDef } from '../../global/interfaces';
import { Observable, Subscription, BehaviorSubject, combineLatest, of } from 'rxjs';

import { Store, select } from '@ngrx/store';
import { AppState } from '../../reducers';
import { formatDateNew } from '../../global/utilities.service';
// 
import {
  selectDocumentsPagination,
  selectDocumentsData,
  selectDocumentsTotal,
  selectDocumentsSort,
  selectDocumentsFilter,
  selectDocumentsFilterFrom,
  selectDocumentsFilterTo,
  selectDocumentsFilterType,
  selectDocumentsMobileData,
  selectDocumentsMobilePagination,
  selectDocumentsMobileState,
  selectDocumentsLoading
} from './documents.selectors';
import {
  selectCountrySelected,
  selectMainFilterAccount,
  selectMainFilterSelectedAccount,
  selectMainFilterSelectedClient
} from '../../shared/layout/main.selectors';
import {
  LoadDocumentsAction,
  SetDocumentsSortAction,
  DocumentsFileDownloadAction,
  SetDocumentsPaginationAction,
  SetDocumentsToFilterAction,
  SetDocumentsFromFilterAction,
  LoadMobileDocumentsAction,
  SetDocumentsMobilePaginationAction,
  ResetDocumentsAction,
  SetDocumentsTypeFilterAction,
} from './documents.actions';
import { map, distinctUntilChanged, take, filter } from 'rxjs/operators';
import { formatDate } from '../../global/dates';
import { DOCUMENTS_TABS, Document, DOCUMENTS_TYPE } from './documents.models';
import { WindowResizeService } from '../../global/window-resize.service';
import { isEqual } from 'lodash';
import * as moment from 'moment';
import { isNullOrUndefined } from 'util';
import { selectAuthUserRole, selectAuthUserType } from '../../features/auth/auth.selectors';
import { selectClientProductDocument } from '../../shared/layout/main.selectors';
import { COUNTRIES } from '../../global/countries';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { TableColumnAlignment } from 'atlas-table';
import { PaginationInfo } from 'atlas-pagination';
import { FieldSize } from 'atlas-cdk';

@Component({
  standalone: false,
  selector: 'dsp-documents',
  templateUrl: 'documents.container.html',
  styleUrls: ['documents.container.scss']
})
export class DocumentsContainerComponent implements OnInit, OnDestroy {
  public env = environment;

  public headers: ColumnDef[] = [
    {
      displayLabel: 'Date',
      fieldKey: 'date',
      sortable: {
        direction: 'desc',
        sortOnLoad: true
      }
    },
    {
      displayLabel: 'Title',
      fieldKey: 'title',
      sortable: true
    },
    {
      displayLabel: 'Fund Name',
      fieldKey: 'fund',
      sortable: true
    },
    {
      displayLabel: 'Action',
      fieldKey: 'action',
      sortable: false,
      // align: TableColumnAlignment.right
    }
  ];
  public micHeaders: ColumnDef[] = [
    {
      name: 'Date',
      column: 'date',
      displayLabel: 'Date',
      fieldKey: 'date'
    },
    {
      name: 'Title',
      column: 'title',
      displayLabel: 'Title',
      fieldKey: 'title'
    },
    {
      name: 'Content Type',
      column: 'fund',
      displayLabel: 'Content Type',
      fieldKey: 'fund'
    },

  ];
  public from: string;
  public defaultFrom: string;
  public to: string;
  public type: string;
  public pagination$: Observable<PaginationInfo>;
  public documents$: Observable<Document[]>;
  public mobileDocuments$: Observable<Document[]>;
  public sort$: Observable<SortInfo>;
  public selectedTabIndex$: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public isMobile$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public showLoadMore$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public showDesc;
  private readonly subscription: Subscription = new Subscription();
  defaultTo: string;
  todate: string;
  todaysDate: string = moment().utc().format('YYYY-MM-DD');
  public account: Object;
  public loading$: Observable<boolean>;
  public internal$: Observable<boolean>;
  public productDocument$: Observable<boolean>;
  public showProductData$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public displayProductTab$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public message = null;
  public country: string;
  public singleSectorFunds;
  public mercerNewZealand;
  public diversifiedFunds;
  sizeMedium = FieldSize.medium;
  sizeSmall = FieldSize.small;
  public constructor(
    private readonly router: Router,
    private readonly store: Store<AppState>,
    private readonly resize: WindowResizeService,
    //public mosConfig: MosConfigurationService
  ) {
    this.loading$ = this.selectLoading();
    this.documents$ = this.selectDocuments();
    this.mobileDocuments$ = this.selectMobileDocuments();
    this.sort$ = this.selectSort();
    this.pagination$ = this.selectPagination();
    this.internal$ = this.selectInternal();
    this.productDocument$ = this.selectProductDocument();
  }

  public ngOnInit(): void {
    this.subscription.add(this.subscribeSelectedCountry());
    this.subscription.add(this.subscribeFilterFrom());
    this.subscription.add(this.subscribeFilterType());
    this.subscription.add(this.subscribeIsMobile());
    this.subscription.add(this.subscribeResetData());
    this.subscription.add(this.subscribeLoadDocuments());
    this.subscription.add(this.subscribeLoadMobileDocuments());
    this.subscription.add(this.subscribeShowLoadMore());
    this.subscription.add(this.subscribeSelectedClient());
  }

  private selectInternal() {
    return this.store.pipe(
      select(selectAuthUserType),
      filter(type => !!type),
      map(type => type === 'internal')
    );
  }

  private selectProductDocument() {
    return this.store.pipe(
      select(selectClientProductDocument),
      filter(productDocument => !!productDocument),
      map(productDocument => productDocument)
    );
  }

  public subscribeSelectedCountry(): Subscription {
    return this.store.pipe(
      select(selectCountrySelected)
    ).subscribe(country => {
      this.country = country;
      if (country === COUNTRIES.au.value) {
        this.singleSectorFunds = CommonConstants.singleSectorFundProductDocAU;
        this.diversifiedFunds = CommonConstants.diversifiedFundProductDocAU;
      } else if (country === COUNTRIES.nz.value) {
        this.mercerNewZealand = CommonConstants.mercerNewZealandProductDocNZ;
      }
    });
  }

  private subscribeResetData(): Subscription {
    return this.store.pipe(
      select(selectMainFilterSelectedAccount)
    ).subscribe(account => {
      if (account) {
        this.store.dispatch(new ResetDocumentsAction());
        this.todaysDate = moment().utc().format('YYYY-MM-DD');
        this.to = this.todaysDate;
        this.from = moment.utc(this.todaysDate).subtract(3, 'year').format('YYYY-MM-DD');
      }
    });
  }

  private selectLoading(): Observable<boolean> {
    return this.store.pipe(
      select(selectDocumentsLoading)
    );
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public formatDate(date: string, format = 'YY-MMM-DD HH:mm'): string {
    return moment.utc(date).format(format);
  }

  public onChangeFrom(event: string): void {
    this.store.pipe(
      select(selectDocumentsFilterFrom),
      take(1)
    ).subscribe(from => {
      if (!!event && formatDateNew(event) !== from) {
        if (!!this.isMobile$.value) {
          this.store.dispatch(new ResetDocumentsAction());
        }
        this.store.dispatch(new SetDocumentsFromFilterAction(formatDateNew(event)));
      }
    });
  }

  public onChangeTo(event: string): void {
    this.todate = formatDateNew(event),
      this.store.pipe(
        select(selectDocumentsFilterTo),
        take(1)
      ).subscribe(to => {
        if (!!event && formatDateNew(event)) {
          if (!!this.isMobile$.value) {
            this.store.dispatch(new ResetDocumentsAction());
          }
          this.store.dispatch(new SetDocumentsToFilterAction(formatDateNew(event)));
        }
      });
  }




  public onPaginate(event: PaginationInfo): void {
    this.store.dispatch(new SetDocumentsPaginationAction(event));
  }

  public onSort(name, direction): void {
    let sortObj: SortInfo = { column: '', reverse: false }
    if (direction && name) {
      sortObj.column = name
      if (direction === 'initial' || direction === 'asc') {
        sortObj.reverse = false
      }
      if (direction === 'desc') {
        sortObj.reverse = true
      }
      this.store.dispatch(new SetDocumentsSortAction(sortObj));
    }
  }
  public onLoadMore(): void {
    this.store.pipe(select(selectDocumentsMobilePagination), take(1)).subscribe(pagination => {
      this.store.dispatch(new SetDocumentsMobilePaginationAction({
        ...pagination,
        page: pagination.page + 1
      }));
    });
  }

  public changeTab(event: number): void {
    // if (event === 3) {
    if (event === DOCUMENTS_TYPE['product-documents']) {
      this.showDesc = true;
    } else {
      this.showDesc = false;
    }
    if (DOCUMENTS_TABS[event] !== this.type) {
      this.store.dispatch(new ResetDocumentsAction());
      this.store.dispatch(new SetDocumentsTypeFilterAction(DOCUMENTS_TABS[event]));
    }
  }

  public exportPDF(id: string, originalName: string): void {
    this.store.dispatch(new DocumentsFileDownloadAction({ id, originalName }));
  }

  private subscribeSelectedClient(): Subscription {
    return combineLatest([
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectCountrySelected)),
      this.store.pipe(select(selectAuthUserType)),
      this.store.pipe(select(selectAuthUserRole))
    ]).pipe(
      filter(([client]) => !!client
      ),
      distinctUntilChanged(isEqual),
      map(([client, account, country, selectAuthUserType, selectAuthUserRole]) => ({
        client, account, country, selectAuthUserType, selectAuthUserRole
      }))
    ).subscribe(payload => {
      // if (payload.selectAuthUserType === 'external' && payload.selectAuthUserRole === 'consultant') {

      if (payload.selectAuthUserType === 'external') {
        if (!payload.client.productDocument) {
          this.displayProductTab$.next(false);
        } else {
          this.displayProductTab$.next(true);
        }
      }
    });
  }

  private subscribeLoadDocuments(): Subscription {
    return combineLatest([
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectDocumentsFilter)),
      this.store.pipe(select(selectDocumentsSort)),
      this.store.pipe(select(selectDocumentsPagination)),
      this.store.pipe(select(selectCountrySelected)),
      this.store.pipe(select(selectAuthUserType)),
      this.store.pipe(select(selectAuthUserRole))
    ]).pipe(
      filter(([client, account]) => !!client
      ),
      distinctUntilChanged(isEqual),
      map(([client, account, filter, sort, pagination, country, selectAuthUserType, selectAuthUserRole]) => ({
        client: client._id,
        account: filter.type === DOCUMENTS_TABS[DOCUMENTS_TYPE['client-documents']] && account ? account._id : '',
        type: filter.type,
        from: filter.from,
        to: filter.to,
        sort,
        pagination,
        country,
        selectAuthUserType,
        productDocument: client.productDocument,
      }))
    ).subscribe(payload => {
      if (payload.selectAuthUserType === 'internal' && payload.type === 'product-documents') {
        if (payload.productDocument === true) {
          this.message = CommonConstants.productDocumentOnMessage;
          this.showProductData$.next(true);
        } else {
          this.message = CommonConstants.productDocumentOffMessage;
          this.showProductData$.next(false);
        }
      } else {
        this.message = null;
      }
      delete payload.productDocument;
      delete payload.selectAuthUserType;
      this.store.dispatch(new LoadDocumentsAction(payload));
    });
  }

  private subscribeLoadMobileDocuments(): Subscription {
    return combineLatest([
      this.store.pipe(select(selectMainFilterSelectedClient)),
      this.store.pipe(select(selectMainFilterSelectedAccount)),
      this.store.pipe(select(selectDocumentsFilter)),
      this.store.pipe(select(selectDocumentsMobilePagination)),
      this.store.pipe(select(selectCountrySelected)),
      this.store.pipe(select(selectDocumentsMobileState)),
      this.isMobile$,
      this.store.pipe(select(selectAuthUserType))

    ]).pipe(
      distinctUntilChanged(isEqual),
      filter(([client, account, filter, pagination, country, state, isMobile]) =>
        !!isMobile && !!client &&
        (state.data.length === 0 ||
          state.data.length === ((pagination.page - 1) * pagination.itemsByPage)) &&
        (state.total === 0 || state.total > state.data.length)
      ),
      map(([client, account, filter, pagination, country, , , selectAuthUserType]) => ({
        client: client._id,
        account: filter.type === DOCUMENTS_TABS[DOCUMENTS_TYPE['client-documents']] && account ? account._id : '',
        ...filter,
        pagination,
        country,
        selectAuthUserType,
        sort: { column: 'title', reverse: false },
        productDocument: client.productDocument
      })),
    ).subscribe(payload => {
      if (payload.selectAuthUserType === 'internal' && payload.type === 'product-documents') {
        if (payload.productDocument === true) {
          this.message = CommonConstants.productDocumentOnMessage;
          this.showProductData$.next(true);
        } else {
          this.message = CommonConstants.productDocumentOffMessage;
          this.showProductData$.next(false);
        }
      } else {
        this.message = null;
      }
      delete payload.productDocument;
      delete payload.selectAuthUserType;
      this.store.dispatch(new LoadMobileDocumentsAction(payload));
    });
  }

  private subscribeShowLoadMore(): Subscription {
    return this.store.pipe(
      select(selectDocumentsMobileState),
      map(state => state.total !== 0 && state.total > state.data.length)
    ).subscribe(this.showLoadMore$);
  }

  private subscribeFilterFrom(): Subscription {
    return combineLatest([
      this.store.pipe(select(selectDocumentsFilterFrom)),
      this.store.pipe(select(selectDocumentsFilterTo)),
    ]).pipe(take(1))
      .subscribe(([from, to]) => {
        if (isNullOrUndefined(this.defaultFrom)) {
          this.defaultTo = moment().utc().format('YYYY-MM-DD'),
            this.defaultFrom = moment.utc(this.defaultTo).subtract(3, 'year').format('YYYY-MM-DD');
          this.from = this.defaultFrom;
          this.to = this.defaultTo;
          this.store.dispatch(new SetDocumentsFromFilterAction(this.defaultFrom));
          this.store.dispatch(new SetDocumentsToFilterAction(this.defaultTo));
        }
      });
  }

  private subscribeFilterType(): Subscription {
    return this.store.pipe(
      select(selectDocumentsFilterType)
    ).subscribe(type => {
      this.type = type;
      this.selectedTabIndex$ = new BehaviorSubject<number>(DOCUMENTS_TABS.indexOf(type));
    });
  }

  private subscribeIsMobile(): Subscription {
    return this.resize.mobile$.subscribe(this.isMobile$);
  }

  private selectDocuments(): Observable<Document[]> {
    return this.store.pipe(
      select(selectDocumentsData),
      map(data => data.map(document => ({
        ...document,
        date: !!document.date ? document.date : '',
        fund: (document.type === 'product-documents')
          ? document.fund.split(',').join(' ') : document.fund
      })))
    );
  }

  private selectMobileDocuments(): Observable<Document[]> {
    return this.store.pipe(
      select(selectDocumentsMobileData),
      map(data => data.map(document => ({
        ...document,
        date: !!document.date ? formatDate(document.date) : '',
        fund: (document.type === 'product-documents')
          ? document.fund.split(',').join(' ') : document.fund,
        fundLength: !isNullOrUndefined(document.fund) && document.fund !== '-' ?
          document.fund.split(',').length : 0,
        multiFund: (!isNullOrUndefined(document.fund) && document.fund !== '-'
          && document.fund.split(',').length > 1) ?
          true : false
      })))
    );
  }

  private selectSort(): Observable<SortInfo> {
    return this.store.pipe(
      select(selectDocumentsSort)
    );
  }

  private selectPagination(): Observable<PaginationInfo> {
    return combineLatest([
      this.store.pipe(select(selectDocumentsPagination)),
      this.store.pipe(select(selectDocumentsTotal)),
    ]).pipe(
      map(([pagination, total]) => ({ ...pagination, total }))
    );
  }

  public capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  getMin(a: number, b: number): number {
    return Math.min(a, b);
  }
}
